import ReactHelmet from "../../../helpers/ReactHelmet";
import Slacks from "../../sources/Slacks";

function Services({ screenWidth }) {
  return (
    <>
      <ReactHelmet
        title="Services"
        content={`Services and slacks used in Full-Stack Development, ReactJs, CSS, HTML, JavaScript, TypeScript, GatsBy, NextJs `}
      />
      <Slacks screenWidth={screenWidth} />
    </>
  );
}

export default Services;
